<div class="hc-segmented" [class.hc-segmented--wrap]="wrap" role="radiogroup">
  <ng-content></ng-content>
</div>
